<template>
  <el-dialog
    :title="form.id ? '编辑员工' : '添加员工'"
    :visible.sync="dialogVisible"
    width="480px"
    append-to-body
    @closed="reset"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <el-form-item label="姓名" prop="name"
        ><el-input v-model.trim="form.name" maxlength="64"
      /></el-form-item>
      <el-form-item label="身份证号" prop="id_card"
        ><el-input v-model.trim="form.id_card" maxlength="18"
      /></el-form-item>
    </el-form>
    <span slot="footer"
      ><el-button @click="dialogVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submit"
        >保存</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import {
  getEmployerEmployeeInfo,
  saveEmployerEmployeeInfo
} from "@/api/employer-insurance";

const validateIdCard = (rule, value, callback) => {
  const idCard = String(value || "").toUpperCase();
  if (!/^\d{17}[\dX]$/.test(idCard)) {
    callback(new Error("请输入正确的18位身份证号"));
    return;
  }

  const birthDate = idCard.slice(6, 14);
  const year = Number(birthDate.slice(0, 4));
  const month = Number(birthDate.slice(4, 6));
  const day = Number(birthDate.slice(6, 8));
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    callback(new Error("身份证号中的出生日期不正确"));
    return;
  }

  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checkCodes = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
  const sum = weights.reduce(
    (total, weight, index) => total + Number(idCard[index]) * weight,
    0
  );
  if (checkCodes[sum % 11] !== idCard[17]) {
    callback(new Error("身份证号校验码不正确"));
    return;
  }
  callback();
};

export default {
  name: "EmployeeLibraryDialog",
  props: {
    visible: { type: Boolean, default: false },
    employeeId: { type: [Number, String], default: "" }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      form: { id: "", name: "", id_card: "" },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        id_card: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validateIdCard, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  watch: {
    visible(value) {
      if (value && this.employeeId) this.loadInfo();
    }
  },
  methods: {
    async loadInfo() {
      this.loading = true;
      try {
        const res = await getEmployerEmployeeInfo({ id: this.employeeId });
        const data = (res && res.data) || {};
        this.form = {
          id: data.id || this.employeeId,
          name: data.name || "",
          id_card: data.id_card || ""
        };
      } finally {
        this.loading = false;
      }
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.submitting = true;
        try {
          const res = await saveEmployerEmployeeInfo({
            ...(this.form.id ? { id: Number(this.form.id) } : {}),
            name: this.form.name,
            id_card: this.form.id_card
          });
          if (!res) return;
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.$emit("success");
        } finally {
          this.submitting = false;
        }
      });
    },
    reset() {
      this.form = { id: "", name: "", id_card: "" };
      if (this.$refs.form) this.$refs.form.clearValidate();
    }
  }
};
</script>
